import { selectUser } from 'containers/Login/loginSlice'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'

const useContactChangeLock = () => {
  const user = useReduxSelector(selectUser)
  const config = useReduxSelector(selectConfig)
  const { push } = useHistory()

  const hasRentals = Number(user?.rentedWarehousesCount) > 0

  const contactSupport = () => {
    if (config?.phoneSupport) window.location.href = `tel:${config.phoneSupport}`
    else push('/help')
  }

  return { hasRentals, contactSupport }
}

export default useContactChangeLock
